import { DentistSettingsService } from './shared/services/dentist-settings.service';
import { DentistProfileService } from './shared/services/dentist-profile.service';
import { GlobalServiceService } from './shared/services/global-service.service';
import { LayoutComponent } from './layout/layout.component';
import { AppRoutingModule } from './app-routing.module';
import { BrowserModule } from '@angular/platform-browser';
import { APP_ID, NgModule } from '@angular/core';

//start new code by vikas
//end new code by vikas

import { AppComponent } from './app.component';
import { provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { BarRatingModule } from "ngx-bar-rating";
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { getMessaging, provideMessaging } from '@angular/fire/messaging';
import { MessagingServiceService } from "./shared/services/messaging-service.service";
import { environment } from '../environments/environment';
import { JQueryService } from './shared/services/jquery.service';
import { CommonModule } from '@angular/common';

@NgModule({
  imports: [
     BrowserModule,
     AppRoutingModule,
     LayoutComponent,
     NgMultiSelectDropDownModule.forRoot(),
     CommonModule,
     BarRatingModule,
  ],
  providers: [
    GlobalServiceService, DentistProfileService, DentistSettingsService, MessagingServiceService,
    JQueryService,
    {provide: APP_ID, useValue: 'serverApp'},
    provideHttpClient(withInterceptorsFromDi()),
    provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    provideFirestore(() => getFirestore()),
    provideAuth(() => getAuth()),
    provideMessaging(() => getMessaging()),
  ],
  bootstrap: [AppComponent]
})
export class AppBrowserModule { }
